// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

// assets
import Playlists from "../assets/icons/playlist-01_w.svg";

const icons = {
  formation: () => <img src={Playlists} alt="formation icon" />,
};
// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const formation = {
  id: "formation",
  title: <FormattedMessage id="formation" />,
  type: "group",
  url: "/formation",
  icon: icons.formation,
  disabled: false,
};

export default formation;
